import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as ImageUrl from "../../../constants/constant.js";
import * as constant from "../../../constants/constant.js";
import 'react-toastify/dist/ReactToastify.css';
import * as marketingActions from '../../../actions/marketingActions';
import * as dashboardActions from "../../../actions/dashboardActions.js";
import { bindActionCreators } from 'redux';
import Autocomplete from 'react-google-autocomplete';
import { Typeahead } from 'react-bootstrap-typeahead';
import '../../../styles/css/disputeSearch.css'
import { ToastContainer, toast } from 'react-toastify';
import DisputeHeader from './disputeHeader.js';
import DisputeFooter from './disputeFooter.js';
// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class DisputeSearch extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            logoutButton: false,
			specializationList: [],
			isReady: false,
			specializationName: '',
			specialization: '',
			searchZipcode: '',
			quickSearchArray: '',
			signUpModelOpen: false,
			signInModelOpen: false,
		};
		this.onChange = this.onChange.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this._logout = this._logout.bind(this);
    }

    search() {

		if (this.state.specialization != undefined || this.state.searchZipcode != undefined) {
			this.setState({
				isSearch: true,
				narrowFilter: true,
			});

			localStorage.setItem('zipcode', this.state.searchZipcode);
			localStorage.setItem('specializationName', this.state.specializationName);
			localStorage.setItem('specializationId', this.state.specialization);
			this.props.history.push('/marketing/search-specialist');

		} else {
			toast.warning('Please select specialization or enter zipcode')
		}

    }
    
    componentWillMount() {
		this.props.actions.getMarketSpecializationList(this.props);

    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node && this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }
    handleClick = () => {
        if (!this.state.logoutButton) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            logoutButton: !prevState.logoutButton,
        }));
    }
    _logout(event) {
        console.log("this.props", this.props)
        let userId = localStorage.getItem("userId");
        this.props.userActions.logout({ 'userId': userId });

        event.preventDefault();
        localStorage.clear();
        this.props.history.push("/");
    }
    onChange(event) {
		this.setState({
			isReady: true,
			[event.target.name]: event.target.value
		});
	}

    componentWillReceiveProps(nextProps) {

		var state = this.state;
		state.specializationList = (state.specializationList && state.specializationList.length > 0) ? state.specializationList : nextProps.specializationList;
		state.quickSearchArray = (state.specializationList && state.specializationList.length > 0) ? state.specializationList : nextProps.specializationList;
		this.setState(state);
	}


    render() {
		var specializationList = this.state.specializationList ? this.state.specializationList : [];

        var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (user && user.gender == undefined) {
            user = { ...user, gender: 'Male' }
            // localStorage.setItem('user', JSON.stringify(user));
            // user = JSON.parse(localStorage.getItem("user"));
        }
        // var gender = localStorage.getItem('user')
        var defaultImagePath = (user && user.gender) == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        var imagePath = ''
        if (user && user.image == "noUserImage.jpg") {
            imagePath = user && user.gender == 'Male' ?
                constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        } else {
            imagePath =
                ImageUrl.PRODUCTION_IMAGE_URL +
                "uploads/" +
                localStorage.getItem("userId") +
                "/" +
                (user && user.image);
        }
        return (
            <div className="wrapper">
                  <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <DisputeHeader   inputRef={el => this.inputElement = el} _logout={this._logout} handleClick={this.handleClick} logoutButton={this.state.logoutButton} />
                                </div>
                            </div>
                        </div>
                <div className="disputeSearch">

                    <div class="container login-container">
                        <div class="row">
                            <div class="col-md-6 login-form-1">
                                <img src={require('../../../images/images/logo.svg')} alt="" />

                                <p>We're on it, a Medfix representative will be reaching out shortly.</p>
                                <div className="searchFooter d-flex">

                                    <a href="#">Medfix Terms</a>
                                    <span></span>
                                    <a href="#">Medfix Privacy</a>

                                </div>
                                <div className="credits">

                                    <span>&copy; Medfix 2018</span>

                                </div>

                            </div>
                            <div class="col-md-6 login-form-2">

									<div className="banner-form">

                                <div className="input-group inputBg">
                                 <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/family_medicine.png')} alt="" /></i></span>
											{this.state.specialization && this.state.specialization != '' ?
												<Typeahead
													onChange={(selected) => {
														
														this.setState({
															isReady: true,
															specializationName: selected.length !== 0 ? selected[0].label : '',
															specialization: selected.length !== 0 ? selected[0].id : ''
														});
													}}
													id="123"
													options={specializationList}
													defaultValue={this.state.specialization}
													defaultSelected={[{ id: "123", label: this.state.specializationName }]}
												//placeholder="Speciality"
												/> : <Typeahead
													onChange={(selected) => {
														this.setState({
															isReady: true,
															specializationName: selected ? selected[0].label : '',
															specialization: selected ? selected[0].id : ''
														});
													}}
													id="123"
													options={specializationList}
													defaultValue={this.state.specialization}
													//defaultSelected={[{ id: "123", label: this.state.specializationName }]}
													placeholder="Speciality"
												/>
											}
										</div>
										<ToastContainer />
										<div className="input-group inputBg" style={{ marginTop: 10, marginBottom: 10 }}> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/map_icon.png')} alt="" /></i></span>
											{/* < input type="text" className="form-control" name="searchZipcode" placeholder="Near City, Zip Code" value={this.state.searchZipcode} onChange={this.onChange.bind(this)}  /> */}
											<Autocomplete
												id='autocomplete'
												className="form-control cityinput"
												data-toggle="tooltip"
												data-placement="right"
												title="Country, State and City will be automatically filled"
												id="inputAddress2"
												// placeholder="Near City, Zip Code"
												placeholder={`${localStorage.getItem("locality")}, ${localStorage.getItem("localityState")}, ${localStorage.getItem("localityCountry")}`}
												name="searchZipcode"
                                                value={this.state.searchZipcode}
                                                onChange={this.onChange.bind(this)}
												onPlaceSelected={this.updateAddress}
												types={['(regions)']}
												autoComplete='off'

											/>
										</div>
										<div className="form-group">
											<button type="button" className="btn btn-primary btn-search btn-search-responsive" onClick={this.search.bind(this)} >Search</button>
										</div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <DisputeFooter />
            </div>
        );
    }
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        // specialistPatients: state.specialist.specialistPatients
		specializationList: state.marketing.specializationList

    };
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(marketingActions, dispatch),
        userActions: bindActionCreators(dashboardActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DisputeSearch);